<div *transloco="let t; read: 'userSettings'">
  <div class="mb-1 text-title-medium text-on-surface-variant">
    {{ t('language.title.main') }}
  </div>
  <div class="mb-4 text-body-small text-on-surface-variant">
    {{ t('language.title.sub') }}
  </div>
  <schaeffler-language-select
    [reloadOnLanguageChange]="true"
    class="mb-3 block"
  ></schaeffler-language-select>
  <schaeffler-locale-select
    [reloadOnLocaleChange]="true"
    [availableLocales]="availableLocales"
    [defaultLocale]="defaultLocale"
  ></schaeffler-locale-select>
</div>
